export const OBSERVED_PARAMS = {
    GW_PENDING_REVIEWS: "gw-pending-reviews",
    REWARDS_HOME: "rewards-home",
    GW_REWARDS_HOME: "gw-rewards-popup-home",
    GW_REWARDS_EARNING_RULES: "gw-rewards-popup-ways-to-earn",
    GW_REWARDS_SPENDING_RULES: "gw-rewards-popup-ways-to-spend",
} as const;
